"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const HasLength_1 = require("../../shared/HasLength");
const HasSize_1 = require("../../shared/HasSize");
class HasMinNumberOfElementsValidator {
    constructor(minElementCount) {
        this.minElementCount = minElementCount;
    }
    isValid(input) {
        if (HasLength_1.hasLength(input)) {
            return input.length >= this.minElementCount;
        }
        else if (HasSize_1.hasSize(input)) {
            return input.size >= this.minElementCount;
        }
        else {
            return false;
        }
    }
}
exports.HasMinNumberOfElementsValidator = HasMinNumberOfElementsValidator;
//# sourceMappingURL=HasMinNumberOfElementsValidator.js.map